<div class="container">
    @if(firmwareFiles==null||firmwareFiles.length===0){
    <div class="uploadfilecontainer" (click)="firmwareFileInput.click()" appDragNDrop
        (onFileDropped)="handleFirmwareDroppedFiles($event);">
        <input hidden type="file" id="firmwareFileInput" #firmwareFileInput
            (change)="onFirmwareFileInput($event.target ? $event.target['files'] : null)" multiple>
        Drag or Click to Upload
    </div>

    <p class="uploadHelp">What file types are allowed? <mat-icon class="pointer" matTooltip=".bin files are allowed">
            contact_support</mat-icon>
    </p>
    }@else {
    <div>
        <p>Selected File:</p>
        <div class="files-list">
            <p style="width: 100%;"> {{ firmwareFiles[0].name }} @if (!firmwareWorking) {
                <span class="material-icons delete-icon" (click)="deleteFirmwareFile()">delete_forever</span>
                }
            </p>
        </div>

    </div>
    <div class="confirmation-container">
        <mat-checkbox [(ngModel)]="confirmed" color="primary">
            I confirm that the config has been tested and is working correctly
        </mat-checkbox>
        <button mat-raised-button [disabled]="!confirmed" (click)="uploadFirmware();"><span
                class="material-icons">cloud_upload</span>Upload
            File</button>
    </div>
    }
</div>